import { Health } from '@capgo/capacitor-health';
import { create } from 'zustand';
import { isAndroidApp, isIosApp } from '../lib/utils';

interface MobilePhoneState {
	isHealthKitAvailable: boolean;
	setHealthKitAvailability: () => Promise<void>;
}

const useMobilePhoneStore = create<MobilePhoneState>((set) => ({
	isHealthKitAvailable: false,
	setHealthKitAvailability: async () => {
		const available = await checkIsHealthDataAvailable();
		set({ isHealthKitAvailable: available });
	}
}));

export default useMobilePhoneStore;

const checkIsHealthDataAvailable = async () => {
	if (!isIosApp && !isAndroidApp) {
		return false;
	}

	try {
		const { available } = await Health.isAvailable();
		return available;
	} catch {
		return false;
	}
};
